import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=6f93864d&scoped=true&"
import script from "./Activities.vue?vue&type=script&setup=true&lang=js&"
export * from "./Activities.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f93864d",
  null
  
)

export default component.exports